import baseRoute from '../baseRoute';

export default `${baseRoute}/document` as const;
